import {IBox, IBoxes} from "src/store/models";

export const sortBoxesReducer = (oldState: IBoxes, boxesWithUpdatedIds: IBox[]) => boxesWithUpdatedIds
    .reduce((nextState: IBoxes, box: IBox & { selfId: string }) =>
            ({
                ...nextState,
                [box.selfId]: {
                    ...nextState[box.selfId],
                    fruitsIds: box.fruitsIds
                }
            }),
        {...oldState});



// WEBPACK FOOTER //
// ./src/store/reducers/sorting/sortBoxesReducer.ts